import React from 'react'
import PropTypes from 'prop-types'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'

import Header from '../components/Header'
import actions from '../actions/header'
import {User as userActions} from '../../../state/actions'
import loginActions from '../../login/actions/login'
import qs from 'query-string'
//import missingInfoActions from '../../missingInfo/actions/missingInfo'
import depositActions from '../../depositV2/actions/deposit'
import signupActions from '../../signup/actions/signup'
import transferActions from '../../transfer/transfer'

const updateInterval = 60000
const transferInterval = 5000

class HeaderContainer extends React.Component {

  timer = null
  transferTimer = null

  constructor(props) {
    super(props)

    if (props.isLoggedIn) {
      props.updateUserInfo()
      this.timer = setInterval(() => props.updateUserInfo(), updateInterval)
    } else {
      if (this.timer) clearInterval(this.timer)
    }

    props.runTransfer()
    this.transferTimer = setInterval(() => props.runTransfer(), transferInterval)

  }

  handleLink() {
    const redirectRoute = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).r
    switch(redirectRoute) {
      case 'login':
        this.props.openLogin()
        break
      case 'signUp':
        this.props.openSignUp()
        break
      case 'retiro':
        this.props.startDeposit()
        break
      default:
        return
    }
  }

  componentDidMount() {
    this.handleLink()
  }

  componentWillReceiveProps(props) {
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (props.isLoggedIn) {
      this.timer = setInterval(() => props.updateUserInfo(), updateInterval)
    }

  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }

  render() {
    return <Header {...this.props}/>
  }
}

HeaderContainer.propTypes = {
  updateUserInfo: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
}

const mapStateToProps = state => {
  const data = state.ui.header.header
  return {
    tab: data.get('tab'),
    show: data.get('show'),
    showSearchBar: data.get('showSearchBar'),
    isLoggedIn: state.domain.user.token !== '',
    isSearching: data.get('isSearching'),
    error: data.get('error'),
    searchText: data.get('search'),
    user: {
      id: state.domain.user.id + '',
      name: state.domain.user.name,
      lastName: state.domain.user.lastName,
      email: state.domain.user.email,
      picture: state.domain.user.profilePicture,
      items: state.domain.user.items,
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setSearch: search => dispatch(actions.setSearch(search)),
    search: () => dispatch(actions.search()),
    logOut: () => dispatch(userActions.logOut()),
    updateUserInfo: () => dispatch(userActions.updateUserInfo()),
    openLogin: () => dispatch(loginActions.open()),
    // startDeposit: () => dispatch(missingInfoActions.start('deposit')),
    startDeposit: () => dispatch(depositActions.start()),
    openSignUp: () => dispatch(signupActions.open()),
    runTransfer: () => dispatch(transferActions.run()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HeaderContainer))



// WEBPACK FOOTER //
// ./src/sections/header/containers/header.js